import { FormFieldModel } from '../../PageBuilder/models/form-field.model';
import { AbstractFormFieldComponent } from '../../PageBuilder/components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';

export class ExternalDataSourceDateRangeFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
    }
}
